<template>
	<div v-if="user.hasRole(['manager', 'admin', 'staff'])">
		<router-view
			:user="user"
			:isAuth="isAuth">
		</router-view>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/layout/Agreement.vue